<template>
  <div class="solutionWrap">
    <div class="pageBgSty">
      <div class="pageTitle">环境空气质量监测解决方案</div>
      <div class="pageTitleTips">基于物联网、AI智能识别、大数据及云计算等技术，形成环境空气质量监测解决方案</div>
    </div>
    <div class="contentWrapFist">
      <div class="nav-wrap">
        <div class="nav-inner">
          <div class="nav-item" :class="{active:index==activeIndex}" v-for="(item,index) in list" :key="index" @click="handleClick(index)" v-html="item"></div>
        </div>
      </div>
    </div>
    <div class="imgConWrap">
      <component :is="currentCom" ></component>
    </div>
  </div>
</template>

<script>
  import com0 from "./components/com0";
  import com1 from "./components/com1";
  import com2 from "./components/com2";
  import com3 from "./components/com3";
  import com4 from "./components/com4";
  export default {
    components: {
      com0,com1,com2,com3,com4
    },
    data(){
      return{
        activeIndex: 0,
        currentCom:"com0",
        list:["AI环保定制方案","环境空气质<br>量监测方案","恶臭监测方案","扬尘监测方案","温室气体<br>监测方案"],
      }
    },
    methods: {
      handleClick(index) {
        this.activeIndex=index
        this.currentCom="com"+index
      }
    },
    watch: {

    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .solutionWrap
    width 100%
    .pageBgSty
      width 100%
      height 580px
      background url("~@/assets/imgs/page_bg_solution.jpg") no-repeat
      background-size 100% 100%
      display flex
      align-items center
      justify-content center
      flex-direction column
      color white
      .pageTitle
        font-size 30px
        letter-spacing 3px
        margin-bottom 15px
      .pageTitleTips
        letter-spacing 2px
        font-size 20px
    .imgConWrap
      width 1288px
      margin 0 auto
      padding  50px 0
      .img_content
        width 100%
    .contentWrapFist
      width 100%
      margin 0 auto
      position relative
      padding-top 60px
      .nav-wrap
        position absolute
        top -10px
        height 76px
        width 100%
        border-bottom 1px solid #E5E5E5
        display flex
        justify-content center
        .nav-inner
          width 1288px
          display flex
          align-items center
          height 100%
          .nav-item
            flex 1
            height 100%
            display flex
            align-items center
            justify-content center
            padding-top 5px
            box-sizing border-box
            color #888888
            font-size 20px
            cursor pointer
            line-height 25px
            &:hover
              background-color #3E85F1
              color white
          .active
            background-color #3E85F1
            color white
</style>



// WEBPACK FOOTER //
// src/views/solution/solution.vue